/* eslint-disable react-i18n/no-dynamic-translation-keys */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { MultiStepLoaderWrapper, Step, Task } from "../Chatbot.styled";
import { CheckCircle } from "@untitledui/icons/CheckCircle";
import { Spinner } from "../../../../Components/Upload/Upload.styled";
import AdAssistantStore from "../../AdAssistantStore";
import { withRefluxStore } from "../../../../Stores";

const tasks = ["Initializing setup", "Creating assets", "Creating texts", "Finalizing setup"];

const MultiStepLoader = ({ taskStep }) => {
  const { t } = useTranslation();
  const [currentTask, setCurrentTask] = useState(taskStep);

  useEffect(() => {
    setCurrentTask(taskStep);
  }, [taskStep]);

  return (
    <MultiStepLoaderWrapper>
      <AnimatePresence>
        {tasks.map((task, index) => (
          <motion.div
            key={task}
            initial={{ opacity: 0, y: 10 }}
            animate={{
              opacity: index === currentTask ? 1 : 0.5 - Math.abs(index - currentTask) * 0.1,
              y: (index - currentTask) * 20
            }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.5 }}
          >
            <Step>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{
                  opacity: index === currentTask ? 1 : 0.5 - Math.abs(index - currentTask) * 0.1
                }}
                transition={{ duration: 0.5 }}
              >
                <Task>
                  {index === currentTask ? (
                    <Spinner size={24} />
                  ) : index < currentTask ? (
                    <CheckCircle size={24} />
                  ) : null}
                  {t(task)}
                </Task>
              </motion.div>
            </Step>
          </motion.div>
        ))}
      </AnimatePresence>
    </MultiStepLoaderWrapper>
  );
};

export default withRefluxStore(MultiStepLoader, [AdAssistantStore], ["taskStep"]);
